import { handleRest } from '../h2Api'
import {
  futureGraduationOptions,
  GRADUATION_SEARCH_UPDATE,
  MAJOR_SEARCH_UPDATE,
  SCHOOL_SEARCH_UPDATE
} from '../actions/profileCommon'

const initialState = {
  schoolSuggestions: handleRest(null, { result: [] }),
  majorSuggestions: handleRest(null, { result: [] }),
  graduationYearSuggestions: futureGraduationOptions
}
const profileCommon = (state = initialState, action) => {
  switch (action.type) {
    case SCHOOL_SEARCH_UPDATE:
      return {
        ...state,
        schoolSuggestions: {
          ...state.schoolSuggestions,
          ...handleRest(action)
        }
      }

    case MAJOR_SEARCH_UPDATE:
      return {
        ...state,
        majorSuggestions: {
          ...state.majorSuggestions,
          ...handleRest(action)
        }
      }

    case GRADUATION_SEARCH_UPDATE:
      return {
        ...state,
        graduationYearSuggestions: action.options
      }

    default:
      return state
  }
}

export default profileCommon
